import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Result, Row } from 'antd';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import { ExperienceDashboardWrapper, OverviewWrapper, Panel } from './styled';
import useInitializeDashboard from './state/useInitializeDashboard';
import { widgetComponentMap } from './config/componentMap';
import ErrorBoundary from '../common/Retry/ErrorBoundary';
import WidgetErrorBoundary from './common/WidgetErrorBoundary';
import { realTimeModeOnTrendsSelector } from '@src/store/common/selectors';
import useDndUtils from './hooks/useDndUtils';
import useMetaEffects from './hooks/useMetaEffects';

// gird template row (base height) is 25
// all widgets should be in a row x multiple height (span)

const WidgetPanel = (props) => {
  const { widgets, order } = useInitializeDashboard();
  const sensors = useSensors(useSensor(PointerSensor));
  const liveMode = useSelector(realTimeModeOnTrendsSelector);

  useMetaEffects({ enabled: !liveMode });

  const { handleDragEnd } = useDndUtils(order);

  if (liveMode) {
    return <Result subTitle="Widgets are not supported in live mode." />;
  }

  return (
    <ErrorBoundary>
      <ExperienceDashboardWrapper>
        <OverviewWrapper>
          <Row style={{ height: '100%' }}>
            <Col span={24}>
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}
              >
                <SortableContext items={order} strategy={rectSortingStrategy}>
                  <Panel>
                    {widgets.map((widgetConfig: any) => {
                      const { wid, type } = widgetConfig;
                      const WidgetRenderer = widgetComponentMap[type];
                      return (
                        <WidgetErrorBoundary wid={wid} key={wid}>
                          <WidgetRenderer wid={wid} />
                        </WidgetErrorBoundary>
                      );
                    })}
                    {widgets.length === 0 ? (
                      <Result
                        style={{ gridRow: 'span 10' }}
                        subTitle="There are no widgets added. Please use the + Widgets button to add widgets."
                      />
                    ) : (
                      <></>
                    )}
                  </Panel>
                </SortableContext>
              </DndContext>
            </Col>
          </Row>
        </OverviewWrapper>
      </ExperienceDashboardWrapper>
    </ErrorBoundary>
  );
};

export default WidgetPanel;
